import React from "react";

import isArray from "lodash/isArray";

import { Species } from "constants/species";

import { useResolveSpeciesId } from "hooks";

export const ForSpecies = React.memo(
  ({ children, species, selectedSpeciesId }) => {
    const speciesId = useResolveSpeciesId(selectedSpeciesId);

    let visible = false;
    if (isArray(species)) {
      visible = species.includes(speciesId);
    } else if (typeof species === "number") {
      visible = species === speciesId;
    }
    return visible ? children : null;
  },
);

export const ForSheep = ({ children, selectedSpeciesId }) => (
  <ForSpecies species={[Species.SHEEP]} selectedSpeciesId={selectedSpeciesId}>
    {children}
  </ForSpecies>
);

export const ForCattle = ({ children, selectedSpeciesId }) => (
  <ForSpecies species={[Species.CATTLE]} selectedSpeciesId={selectedSpeciesId}>
    {children}
  </ForSpecies>
);

export default ForSpecies;
